import { router } from "@/core";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
import { defineComponent, reactive } from "vue";
import { projectStatusArr, contractStatusArr } from "./project-status-tabs.constant";
import { get, post } from "./project-status-tabs.service";
import { TabsType } from "./project-status-tabs.interface";
import _ from "lodash";

export default defineComponent({
  isGlobal: true,
  name: "ProjectStatusTab",
  components: {},
  props: {
    path: {
      type: String,
      require: true,
    },
    statusType: {
      type: String,
      default: "project",
    },
    value: {
      type: String,
    },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    let { data, run, refresh } = get();
    let flowCountMap = new Map();
    let total = 0;

    let flowStatusArr = reactive<TabsType[]>([]);

    flowStatusArr =props.statusType == "project"? projectStatusArr:contractStatusArr;
    const fetchStatusCount = async () => {
      await run(props.path);
      getCount();
    };
    const getCount = () => {
      total = 0;
      flowCountMap.clear();
      // console.log("🚀 ~ file: project-status-tab.controller.ts:45 ~ getCount ~ flowCountMap:", flowCountMap)
      let list = data.value?.countResp || [];
      list.map((d) => {
        flowCountMap.set(d.code, d);
        total += d.count;
      });
      flowStatusArr.map((item) => {
        item["total"] = flowCountMap.get(item.type)?.count || 0;
        if (item.type == "all") {
          item["total"] = total;
        }
      });
    };

    const changeTab = (p) => {
      emit("update:value", p);
    };

    onMountedOrActivated(async () => {
      await fetchStatusCount();
    });

    const onProjectDesign = () => {
      router.push("/project/profile/create");
    };

    return {
      flowStatusArr,
      changeTab,
      getCount,
      onProjectDesign,
      fetchStatusCount,
    };
  },
});
